import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Mottagningsplats } from "~app/common/models/lagerplats/MottagningsplatsListResponseDTO";
import { SearchMottagningsplatsResultViewmodel } from "./search-mottagningsplats-result.viewmodel";

@Component({
    selector: "rask-search-mottagningsplats-result",
    templateUrl: "./search-mottagningsplats-result.component.html",
    styleUrls: ["./search-mottagningsplats-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        TranslatePipe
    ]
})
export class SearchMottagningsplatsResultComponent {
    results: SearchMottagningsplatsResultViewmodel[];

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("results") set list(val: Mottagningsplats[]) {
        if (!val) {
            return;
        }
        this.results = val.map((x) => new SearchMottagningsplatsResultViewmodel(x));
    }
}
